/*
	jv.ModalWidget.js

	This widget's purpose is to be a standalone modal shower widget. It models the widget found on the Candidates List Page (when you click the info button)

	Documentation:
	This widget relies on three styles which are loaded via the initStyleSheets. If others are needed in the future, they should
	be added to that function.

	To initialize this widget, create a
		<div id="jv-modalDialog" class="jqDnR jqmWindow"></div>
	This is the div where the modal data will be loaded.

	add jv.modalNew.init( theDataObject, theContext ) to the onClick event of the DOM element you want to trigger the widget to init the widget.
*/
var jv = {};
jv.modalNew = {};
var JV = JV || {};
JV.AJAX_URL = "/TalentNetwork/action/person/applicantList";
jv.modalNew = {

	appId: "",
	candId: "",
	/*
	 * Initializes the widget.
	 *
	 */
	init: function (data, context, noLiveEvent) {
		this.injectStyleSheets();
		this.initLiveEvents(noLiveEvent);
		var _reqsObject = this.createReqsObject(data);
		jv.modalNew.context = context;
		this.render(_reqsObject);
		return true;
	},

	/*
	 * Render - Creates the Ajax call to the backend for the HTML content and renders it through modalShow on success.
	 */
	render: function (params, callback) {
		var args = {};
		args.ajaxType = params.action;
		args.url = JV.AJAX_URL;
		if (callback) {
			args.success = callback;
		}
		else {
			args.success = function (content) {
				jv.modalNew.modalShow(content);
			}
		}
		args.data = params;
		this.makeAjaxRequest(args);
	},

	/*
	 * getApplicationDetailsUrl 
	 * Purpose: To land the _url to default tab of the candidate details page
	 */
	getApplicationDetailsUrl: function (appId, master, section) {
		var readMode = 1;
		if (appId == null) {
			$log.error('appId is required for application details');
			return;
		}
		if (!section) {
			section = 'profile';
		}
		if (master) {
			readMode = 0;
		}
		return window.jvUrls.jhire + '/modules/candidates/details.html?readMode={0}&applicationId={1}&mode=paginate#/{2}/{3}'.format(readMode, appId, section, appId);
	},
	/*
	 * initLiveEvents
	 * Purpose: A place to place all the onClick events that pertain to the widget.
	 */
  initLiveEvents: function (noLiveEvent) {
    $(document).on('click', "span[KEY='CANCEL']", function () {
      $("#jv-modalDialog").jqmHide();
      jv.modalNew.removeStyleSheets();
    });
    if (!noLiveEvent) {
      $(document).on("click", ".jvdb-center", function () {
        var _url = jv.modalNew.getApplicationDetailsUrl(jv.modalNew.appId);
        window.open(_url, "_blank");
        return false;
      });
    }
  },

	/*
	 * @param: data
			data must have eid
			Can have:
				id
				next
				prev
				page
				totalpages
				selectedTab
	 */
	createReqsObject: function (data) {
		var _reqsObject = {}; // the object to be returned with the information on the query to be pulled.
		var _hrTech; // boolean value that checks if hrTech is enabled or not.

		_reqsObject = {
			action: "getQuickViewForm",
			ids: data.id,
			eids: data.eid,
			next: data.next,
			previous: data.prev,
			page: data.page,
			totalPages: data.totalPages,
			selectedTab: data.selectedTab
		}
		_reqsObject.request = JSON.stringify(_reqsObject);
		this.appId = data.id;
		this.candId = data.candId;

		return _reqsObject;
	},

	makeAjaxRequest: function (args) {
		args.contentType = args.contentType ? args.contentType : 'application/x-www-form-urlencoded;charset=utf-8';
		args.type = 'POST';
		args.headers = {
			"Accept": "text/html",
		};
		if (args.data) {
			args.data.enableHRUI = true;
		}
		args.url = args.url ? args.url : JV.AJAX_URL;
		$.ajax(args);
	},

	modalShow: function (content) {
    $("#" + this.context).jqm({modal: true});
    $("#" + this.context).html(content);
		$("#" + this.context).jqmShow();
		this.cssFixes();
	},

	cssFixes: function () {
		//	some css overwrites
		$(".jvdb-left-light").css("background", "none");
		$(".jvdb-right-light").css("background", "none");
		$(".jvdb-left").css("background", "none");
		$(".jvdb-right").css("background", "none");
	},

	injectStyleSheets: function () {
		var _script = document.createElement("link");
		_script.href = "/__assets__/styles/library/custom/JV.FriendWidget.css";
		_script.rel = "stylesheet";
		_script.id = "FriendWidget";

		var _script2 = document.createElement("link");
		_script2.href = "/__assets__/styles/library/custom/modalWidget.css";
		_script2.rel = "stylesheet";
		_script2.id = "ModalWidget";

		var _script3 = document.createElement("link");
		_script3.href = "/__assets__/styles/source/person/JV.Candidates.css";
		_script3.rel = "stylesheet";
		_script3.id = "ModalWidget2";


		$('head').prepend(_script2);
		$('head').prepend(_script);
	},

	removeStyleSheets: function () {
		$("#ModalWidget").remove();
		$("#FriendWidget").remove();
		$("#ModalWidget2").remove();
	}
};

/************LIBRARY INCLUDES *******/
/*
 * jqModal - Minimalist Modaling with jQuery
 *   (http://dev.iceburg.net/jquery/jqModal/)
 *
 * Copyright (c) 2007,2008 Brice Burgess <bhb@iceburg.net>
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 * $Version: 03/01/2009 +r14
 */
(function ($) {
  $.fn.jqm = function (o) {
    var p = {
      overlay: 50,
      overlayClass: 'jqmOverlay',
      closeClass: 'jqmClose',
      trigger: '.jqModal',
      ajax: false,
      ajaxText: '',
      target: false,
      modal: false,
      toTop: false,
      onShow: false,
      onHide: false,
      onLoad: false,
    };
    return this.each(function () {
      if (this._jqm) return (H[this._jqm].c = $.extend({}, H[this._jqm].c, o));
      s++;
      this._jqm = s;
      H[s] = {
        c: $.extend({}, p, $.jqm.params, o),
        a: false,
        w: $(this).addClass('jqmID' + s),
        s: s,
      };
      if (p.trigger) $(this).jqmAddTrigger(p.trigger);
    });
  };

  $.fn.jqmAddClose = function (e) {
    return hs(this, e, 'jqmHide');
  };
  $.fn.jqmAddTrigger = function (e) {
    return hs(this, e, 'jqmShow');
  };
  $.fn.jqmShow = function (t) {
    return this.each(function () {
      t = t || window.event;
      $.jqm.open(this._jqm, t);
      var _top = $(document).scrollTop() + 10 + 'px';
      if (typeof window._HRTECHUI_ENABLED !== 'undefined' && window._HRTECHUI_ENABLED === true) {
        $('.jqmWindow').css('top', '-800px');
        $('.jqmWindow').removeClass('jqmWindowAnimateClass');
        $('.jqmWindow').animate({ top: _top }, 300);
      } else {
        $('.jqmWindow').css('top', _top);
      }
    });
  };
  $.fn.jqmHide = function (t) {
    return this.each(function () {
      t = t || window.event;
      $.jqm.close(this._jqm, t);
    });
  };

  $.jqm = {
    hash: {},
    open: function (s, t) {
      var t_height = $('body').height();
      var h = H[s],
        c = h.c,
        cc = '.' + c.closeClass,
        z = parseInt(h.w.css('z-index')),
        z = z > 0 ? z : 3000,
        o = $('<div></div>').css({
          height: '100%',
          width: '100%',
          position: 'fixed',
          left: 0,
          top: 0,
          'z-index': z - 1,
          opacity: c.overlay / 100,
        });
      if (h.a) return false;
      h.t = t;
      h.a = true;
      h.w.css('z-index', z);
      if (typeof window._HRTECHUI_ENABLED !== 'undefined' && window._HRTECHUI_ENABLED === true) {
        h.w.addClass('jqmWindowAnimateClass');
      }
      if (c.modal) {
        if (!A[0]) L('on');
        A.push(s);
      } else if (c.overlay > 0) h.w.jqmAddClose(o);
      else o = false;

      h.o = o ? o.addClass(c.overlayClass).prependTo('body') : false;

      if (c.ajax) {
        var r = c.target || h.w,
          u = c.ajax,
          r = typeof r === 'string' ? $(r, h.w) : $(r),
          u = u.substr(0, 1) === '@' ? $(t).attr(u.substring(1)) : u;
        r.html(c.ajaxText).load(u, function () {
          if (c.onLoad) c.onLoad.call(this, h);
          if (cc) h.w.jqmAddClose($(cc, h.w));
        });
      } else if (cc) h.w.jqmAddClose($(cc, h.w));

      if (c.toTop && h.o) h.w.before('<span id="jqmP' + h.w[0]._jqm + '"></span>').insertAfter(h.o);
      c.onShow ? c.onShow(h) : h.w.show();
      return false;
    },
    close: function (s) {
      var h = H[s];
      if (!h.a) return false;
      h.a = false;
      if (A[0]) {
        A.pop();
        if (!A[0]) L('off');
      }
      if (h.c.toTop && h.o) $('#jqmP' + h.w[0]._jqm).after(h.w).remove();
      if (h.c.onHide) h.c.onHide(h);
      else {
        if (typeof window._HRTECHUI_ENABLED !== 'undefined' && window._HRTECHUI_ENABLED === true) {
          $(h.w).animate(
            {
              top: '-800px',
            },
            300,
            function () {
              h.w.hide();
              if (h.o) h.o.remove();
            }
          );
        } else {
          h.w.hide();
          if (h.o) h.o.remove();
        }
      }
      return false;
    },
    params: {},
  };
  var s = 0,
    H = $.jqm.hash,
    A = [],
    falseFlag = false,
    i = $('<iframe src="javascript:false;document.write(\'\');" class="jqm"></iframe>').css({ opacity: 0 });
  var L = function (t) {
    $()
      [t]('keypress', m)
      [t]('keydown', m)
      [t]('mousedown', m);
  };
  var m = function (e) {
    var h = H[A[A.length - 1]],
      r = !$(e.target).parents('.jqmID' + h.s)[0];
    return !r;
  };
  var hs = function (w, t, c) {
    return w.each(function () {
      var s = this._jqm;
      $(t).each(function () {
        if (!this[c]) {
          this[c] = [];
          $(this).click(function () {
            for (var i in { jqmShow: 1, jqmHide: 1 })
              for (var s in this[i]) if (H[this[i][s]]) H[this[i][s]].w[i](this);
            return falseFlag;
          });
        }
        this[c].push(s);
      });
    });
  };
})(jQuery);

/**
 * modified version of the dragging to fit with the new version of jquery.
 * modified by: Varun
 * NOTE: changing or accessing the css property of the element is messing the tooltips in IE so commenting it out.
 */

(function ($) {
	$.jqDnR = {
		dnr: {},
		e: 0,
		drag: function (v) {
			var _top = M.Y + v.pageY - M.pY;
			_top = _top > 0 ? _top : 0;
			if (M.k == 'd') E.css({
				left: M.X + v.pageX - M.pX, top: _top
			});
			else E.css({
				width: Math.max(v.pageX - M.pX + M.W, 0), height: Math.max(v.pageY - M.pY + M.H, 0)
			});
			return false;
		},

		stop: function () {
			$(document).off('mousemove').off('mouseup');
		}
	};
	var J = $.jqDnR, M = J.dnr, E = J.e,
		i = function (e, h, k) {
			return e.each(function () {
				h = (h) ? $(h, e) : e;
				h.on('mousedown', { e: e, k: k }, function (v) {
					var d = v.data, p = {}; E = d.e;
					// attempt utilization of dimensions plugin to fix IE issues
					if (E.css('position') != 'relative') {
						try {
							E.position({}, p);
						} catch (e) { }
					}
					M = {
						X: p.left || f('left') || 0, Y: p.top || f('top') || 0, W: f('width') || E[0].scrollWidth || 0, H: f('height') || E[0].scrollHeight || 0, pX: v.pageX, pY: v.pageY, k: d.k//,o:E.css('opacity')
					};
					$(document).mousemove(function (e) {
						$.jqDnR.drag(e)
					}).mouseup(function (e) {
						$.jqDnR.stop(e)
					});
					return false;
				});
			});
		},
		f = function (k) {
			//return parseInt(E.css(k))||false;
		};
})(jQuery);
window.jv = jv;